import { styled } from 'styled-components'

import { SpinnerDots, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const LoadingContainer = styled.div`
  display: flex;
  gap: 0.75rem;
`

const ChangeDeliveryMethodLoader = () => (
  <LoadingContainer>
    <FormattedMessage id="Auction.details.receiveGoods.title.loading" />
    <SpinnerDots />
  </LoadingContainer>
)

export default ChangeDeliveryMethodLoader
